const getFlexibleCompensationConfig = async (token: string) => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/companies/flexible-compensation-config`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	return response.json();
};

export default getFlexibleCompensationConfig;
